import { render, staticRenderFns } from "./AboutSpeech.vue?vue&type=template&id=ba86a9d6&"
import script from "./AboutSpeech.vue?vue&type=script&lang=js&"
export * from "./AboutSpeech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports